import { render, staticRenderFns } from "./fotters.vue?vue&type=template&id=71ba9184&lang=true&"
import script from "./fotters.vue?vue&type=script&lang=js&"
export * from "./fotters.vue?vue&type=script&lang=js&"
import style0 from "./fotters.vue?vue&type=style&index=0&id=71ba9184&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports